"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var react_sortable_hoc_1 = require("react-sortable-hoc");

var DragIndicator_1 = __importDefault(require("@material-ui/icons/DragIndicator"));

var sortable_text_option_list_styles_1 = require("./sortable-text-option-list.styles");

var editable_text_option_row_container_1 = __importDefault(require("../editable-text-option-row/editable-text-option-row.container"));

var DragHandler = react_sortable_hoc_1.SortableHandle(function () {
  return react_1.default.createElement(DragIndicator_1.default, null);
});
var SortableItem = react_sortable_hoc_1.SortableElement(function (props) {
  return react_1.default.createElement(sortable_text_option_list_styles_1.StyledSortableLi, {
    key: props.optionIndex
  }, react_1.default.createElement(DragHandler, null), react_1.default.createElement(editable_text_option_row_container_1.default, Object.assign({}, props)));
});
var SortableTextOptionList = react_sortable_hoc_1.SortableContainer(function (_ref) {
  var nodeId = _ref.nodeId,
      options = _ref.options;
  return react_1.default.createElement(sortable_text_option_list_styles_1.StyledSortableUl, null, options.map(function (option, i) {
    return react_1.default.createElement(SortableItem, {
      index: i,
      key: i,
      nodeId: nodeId,
      option: option,
      optionIndex: i
    });
  }));
});
exports.default = SortableTextOptionList;